"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/stock-corporate-action.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fstock-corporate-action.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergerAcquisitionTypeToJSON = exports.mergerAcquisitionTypeFromJSON = exports.dividendTaxTypeToJSON = exports.dividendTaxTypeFromJSON = exports.dividendTaxCodeToJSON = exports.dividendTaxCodeFromJSON = exports.dividendTypeToJSON = exports.dividendTypeFromJSON = exports.StockSpinoff = exports.StockSplit = exports.MergerAcquisition = exports.DividendTax = exports.Dividend = exports.MergerAcquisitionType = exports.DividendTaxType = exports.DividendTaxCode = exports.DividendType = void 0;
const amount_1 = require("./amount");
const protobufPackage = 'com.step.common.stock.proto';
/**
 * Dividend type
 */
var DividendType;
(function (DividendType) {
    DividendType["INVALID_DIVIDEND_TYPE"] = "INVALID_DIVIDEND_TYPE";
    DividendType["CASH"] = "CASH";
    DividendType["STOCK"] = "STOCK";
    DividendType["RETURN_OF_CAPITAL"] = "RETURN_OF_CAPITAL";
    DividendType["DISTRIBUTION_LONG"] = "DISTRIBUTION_LONG";
    DividendType["DISTRIBUTION_SHORT"] = "DISTRIBUTION_SHORT";
    DividendType["OTHER_DIVIDEND_TYPE"] = "OTHER_DIVIDEND_TYPE";
    DividendType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DividendType || (exports.DividendType = DividendType = {}));
/**
 * Dividend tax code
 */
var DividendTaxCode;
(function (DividendTaxCode) {
    DividendTaxCode["INVALID_DIVIDEND_TAX_CODE"] = "INVALID_DIVIDEND_TAX_CODE";
    DividendTaxCode["FULLY_TAXABLE"] = "FULLY_TAXABLE";
    DividendTaxCode["NON_TAXABLE"] = "NON_TAXABLE";
    DividendTaxCode["TAX_EXEMPT"] = "TAX_EXEMPT";
    DividendTaxCode["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DividendTaxCode || (exports.DividendTaxCode = DividendTaxCode = {}));
var DividendTaxType;
(function (DividendTaxType) {
    DividendTaxType["INVALID_DIVIDEND_TAX_TYPE"] = "INVALID_DIVIDEND_TAX_TYPE";
    DividendTaxType["FOREIGN_TAX"] = "FOREIGN_TAX";
    DividendTaxType["NON_RESIDENT_ALIEN"] = "NON_RESIDENT_ALIEN";
    DividendTaxType["OTHER_DIVIDEND_TAX_TYPE"] = "OTHER_DIVIDEND_TAX_TYPE";
    DividendTaxType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DividendTaxType || (exports.DividendTaxType = DividendTaxType = {}));
var MergerAcquisitionType;
(function (MergerAcquisitionType) {
    MergerAcquisitionType["INVALID_MERGER_ACQUISITION_TYPE"] = "INVALID_MERGER_ACQUISITION_TYPE";
    MergerAcquisitionType["EXCHANGE_STOCK_CASH"] = "EXCHANGE_STOCK_CASH";
    MergerAcquisitionType["ADD_SHARES"] = "ADD_SHARES";
    MergerAcquisitionType["ADD_SHARES_CASH"] = "ADD_SHARES_CASH";
    MergerAcquisitionType["ADD_SHARES_REMOVE_CASH"] = "ADD_SHARES_REMOVE_CASH";
    MergerAcquisitionType["REMOVE_SHARES"] = "REMOVE_SHARES";
    MergerAcquisitionType["REMOVE_SHARES_CASH"] = "REMOVE_SHARES_CASH";
    MergerAcquisitionType["REMOVE_SHARES_ADD_CASH"] = "REMOVE_SHARES_ADD_CASH";
    MergerAcquisitionType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(MergerAcquisitionType || (exports.MergerAcquisitionType = MergerAcquisitionType = {}));
function createBaseDividend() {
    return {
        amountPerShare: amount_1.Amount.fromPartial({}),
        type: DividendType.INVALID_DIVIDEND_TYPE,
        taxCode: DividendTaxCode.INVALID_DIVIDEND_TAX_CODE,
    };
}
exports.Dividend = {
    fromJSON(object) {
        const message = {
            amountPerShare: isSet(object.amountPerShare)
                ? amount_1.Amount.fromJSON(object.amountPerShare)
                : amount_1.Amount.fromPartial({}),
            type: isSet(object.type)
                ? dividendTypeFromJSON(object.type)
                : DividendType.INVALID_DIVIDEND_TYPE,
        };
        if (isSet(object.taxCode)) {
            message.taxCode = dividendTaxCodeFromJSON(object.taxCode);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amountPerShare !== undefined) {
            obj.amountPerShare = amount_1.Amount.toJSON(message.amountPerShare);
        }
        if (message.type !== DividendType.INVALID_DIVIDEND_TYPE) {
            obj.type = dividendTypeToJSON(message.type);
        }
        if (message.taxCode !== undefined && message.taxCode !== DividendTaxCode.INVALID_DIVIDEND_TAX_CODE) {
            obj.taxCode = dividendTaxCodeToJSON(message.taxCode);
        }
        return obj;
    },
    create(base) {
        return exports.Dividend.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDividend();
        message.amountPerShare = (object.amountPerShare !== undefined && object.amountPerShare !== null)
            ? amount_1.Amount.fromPartial(object.amountPerShare)
            : amount_1.Amount.fromPartial({});
        message.type = object.type ?? DividendType.INVALID_DIVIDEND_TYPE;
        message.taxCode = object.taxCode ?? DividendTaxCode.INVALID_DIVIDEND_TAX_CODE;
        return message;
    },
};
function createBaseDividendTax() {
    return { rate: '', type: DividendTaxType.INVALID_DIVIDEND_TAX_TYPE };
}
exports.DividendTax = {
    fromJSON(object) {
        const message = {
            rate: isSet(object.rate) ? globalThis.String(object.rate) : '',
            type: isSet(object.type)
                ? dividendTaxTypeFromJSON(object.type)
                : DividendTaxType.INVALID_DIVIDEND_TAX_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.rate !== '') {
            obj.rate = message.rate;
        }
        if (message.type !== DividendTaxType.INVALID_DIVIDEND_TAX_TYPE) {
            obj.type = dividendTaxTypeToJSON(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.DividendTax.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDividendTax();
        message.rate = object.rate ?? '';
        message.type = object.type ?? DividendTaxType.INVALID_DIVIDEND_TAX_TYPE;
        return message;
    },
};
function createBaseMergerAcquisition() {
    return { type: MergerAcquisitionType.INVALID_MERGER_ACQUISITION_TYPE };
}
exports.MergerAcquisition = {
    fromJSON(object) {
        const message = {
            type: isSet(object.type)
                ? mergerAcquisitionTypeFromJSON(object.type)
                : MergerAcquisitionType.INVALID_MERGER_ACQUISITION_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== MergerAcquisitionType.INVALID_MERGER_ACQUISITION_TYPE) {
            obj.type = mergerAcquisitionTypeToJSON(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.MergerAcquisition.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMergerAcquisition();
        message.type = object.type ?? MergerAcquisitionType.INVALID_MERGER_ACQUISITION_TYPE;
        return message;
    },
};
function createBaseStockSplit() {
    return {};
}
exports.StockSplit = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.StockSplit.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseStockSplit();
        return message;
    },
};
function createBaseStockSpinoff() {
    return {};
}
exports.StockSpinoff = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.StockSpinoff.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseStockSpinoff();
        return message;
    },
};
function dividendTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_DIVIDEND_TYPE':
            return DividendType.INVALID_DIVIDEND_TYPE;
        case 1:
        case 'CASH':
            return DividendType.CASH;
        case 2:
        case 'STOCK':
            return DividendType.STOCK;
        case 3:
        case 'RETURN_OF_CAPITAL':
            return DividendType.RETURN_OF_CAPITAL;
        case 4:
        case 'DISTRIBUTION_LONG':
            return DividendType.DISTRIBUTION_LONG;
        case 5:
        case 'DISTRIBUTION_SHORT':
            return DividendType.DISTRIBUTION_SHORT;
        case 6:
        case 'OTHER_DIVIDEND_TYPE':
            return DividendType.OTHER_DIVIDEND_TYPE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return DividendType.UNRECOGNIZED;
    }
}
exports.dividendTypeFromJSON = dividendTypeFromJSON;
function dividendTypeToJSON(object) {
    switch (object) {
        case DividendType.INVALID_DIVIDEND_TYPE:
            return 'INVALID_DIVIDEND_TYPE';
        case DividendType.CASH:
            return 'CASH';
        case DividendType.STOCK:
            return 'STOCK';
        case DividendType.RETURN_OF_CAPITAL:
            return 'RETURN_OF_CAPITAL';
        case DividendType.DISTRIBUTION_LONG:
            return 'DISTRIBUTION_LONG';
        case DividendType.DISTRIBUTION_SHORT:
            return 'DISTRIBUTION_SHORT';
        case DividendType.OTHER_DIVIDEND_TYPE:
            return 'OTHER_DIVIDEND_TYPE';
        case DividendType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.dividendTypeToJSON = dividendTypeToJSON;
function dividendTaxCodeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_DIVIDEND_TAX_CODE':
            return DividendTaxCode.INVALID_DIVIDEND_TAX_CODE;
        case 1:
        case 'FULLY_TAXABLE':
            return DividendTaxCode.FULLY_TAXABLE;
        case 2:
        case 'NON_TAXABLE':
            return DividendTaxCode.NON_TAXABLE;
        case 3:
        case 'TAX_EXEMPT':
            return DividendTaxCode.TAX_EXEMPT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return DividendTaxCode.UNRECOGNIZED;
    }
}
exports.dividendTaxCodeFromJSON = dividendTaxCodeFromJSON;
function dividendTaxCodeToJSON(object) {
    switch (object) {
        case DividendTaxCode.INVALID_DIVIDEND_TAX_CODE:
            return 'INVALID_DIVIDEND_TAX_CODE';
        case DividendTaxCode.FULLY_TAXABLE:
            return 'FULLY_TAXABLE';
        case DividendTaxCode.NON_TAXABLE:
            return 'NON_TAXABLE';
        case DividendTaxCode.TAX_EXEMPT:
            return 'TAX_EXEMPT';
        case DividendTaxCode.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.dividendTaxCodeToJSON = dividendTaxCodeToJSON;
function dividendTaxTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_DIVIDEND_TAX_TYPE':
            return DividendTaxType.INVALID_DIVIDEND_TAX_TYPE;
        case 1:
        case 'FOREIGN_TAX':
            return DividendTaxType.FOREIGN_TAX;
        case 2:
        case 'NON_RESIDENT_ALIEN':
            return DividendTaxType.NON_RESIDENT_ALIEN;
        case 3:
        case 'OTHER_DIVIDEND_TAX_TYPE':
            return DividendTaxType.OTHER_DIVIDEND_TAX_TYPE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return DividendTaxType.UNRECOGNIZED;
    }
}
exports.dividendTaxTypeFromJSON = dividendTaxTypeFromJSON;
function dividendTaxTypeToJSON(object) {
    switch (object) {
        case DividendTaxType.INVALID_DIVIDEND_TAX_TYPE:
            return 'INVALID_DIVIDEND_TAX_TYPE';
        case DividendTaxType.FOREIGN_TAX:
            return 'FOREIGN_TAX';
        case DividendTaxType.NON_RESIDENT_ALIEN:
            return 'NON_RESIDENT_ALIEN';
        case DividendTaxType.OTHER_DIVIDEND_TAX_TYPE:
            return 'OTHER_DIVIDEND_TAX_TYPE';
        case DividendTaxType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.dividendTaxTypeToJSON = dividendTaxTypeToJSON;
function mergerAcquisitionTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_MERGER_ACQUISITION_TYPE':
            return MergerAcquisitionType.INVALID_MERGER_ACQUISITION_TYPE;
        case 1:
        case 'EXCHANGE_STOCK_CASH':
            return MergerAcquisitionType.EXCHANGE_STOCK_CASH;
        case 2:
        case 'ADD_SHARES':
            return MergerAcquisitionType.ADD_SHARES;
        case 3:
        case 'ADD_SHARES_CASH':
            return MergerAcquisitionType.ADD_SHARES_CASH;
        case 4:
        case 'ADD_SHARES_REMOVE_CASH':
            return MergerAcquisitionType.ADD_SHARES_REMOVE_CASH;
        case 5:
        case 'REMOVE_SHARES':
            return MergerAcquisitionType.REMOVE_SHARES;
        case 6:
        case 'REMOVE_SHARES_CASH':
            return MergerAcquisitionType.REMOVE_SHARES_CASH;
        case 7:
        case 'REMOVE_SHARES_ADD_CASH':
            return MergerAcquisitionType.REMOVE_SHARES_ADD_CASH;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return MergerAcquisitionType.UNRECOGNIZED;
    }
}
exports.mergerAcquisitionTypeFromJSON = mergerAcquisitionTypeFromJSON;
function mergerAcquisitionTypeToJSON(object) {
    switch (object) {
        case MergerAcquisitionType.INVALID_MERGER_ACQUISITION_TYPE:
            return 'INVALID_MERGER_ACQUISITION_TYPE';
        case MergerAcquisitionType.EXCHANGE_STOCK_CASH:
            return 'EXCHANGE_STOCK_CASH';
        case MergerAcquisitionType.ADD_SHARES:
            return 'ADD_SHARES';
        case MergerAcquisitionType.ADD_SHARES_CASH:
            return 'ADD_SHARES_CASH';
        case MergerAcquisitionType.ADD_SHARES_REMOVE_CASH:
            return 'ADD_SHARES_REMOVE_CASH';
        case MergerAcquisitionType.REMOVE_SHARES:
            return 'REMOVE_SHARES';
        case MergerAcquisitionType.REMOVE_SHARES_CASH:
            return 'REMOVE_SHARES_CASH';
        case MergerAcquisitionType.REMOVE_SHARES_ADD_CASH:
            return 'REMOVE_SHARES_ADD_CASH';
        case MergerAcquisitionType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.mergerAcquisitionTypeToJSON = mergerAcquisitionTypeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=stock-corporate-action.js.map